// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";


export enum FileLinkEntity {
    UNDEFINED_FileLinkEntity = 0,
    USER_PICTURE = 1,
    ORGA_LOGO = 2,
    CONTACT_PHOTO = 3,
    COMPANY_LOGO = 4,
}
export interface IFileLink {
    entity?: FileLinkEntity;
    id?: number;

}
export class FileLink implements IFileLink {

    entity?: FileLinkEntity;
    id?: number;

    constructor(data?: Partial<IFileLink>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MFileLink extends Message implements FileLink {

    constructor(data?: Partial<IFileLink>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("entity" in data && data.entity != undefined) this.entity = data.entity;
            if ("id" in data && data.id != undefined) this.id = data.id;
        }
    }

    get entity(): FileLinkEntity {
        return Message.getField(this, 1) as FileLinkEntity;
    }
    set entity(value: FileLinkEntity) {
        Message.setField(this, 1, value);
    }

    get id(): number {
        return Message.getField(this, 2) as number;
    }
    set id(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new FileLink() : {} as FileLink;
        if (this.entity != undefined) data.entity = this.entity;
        if (this.id != undefined) data.id = this.id;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.entity !== undefined) writer.writeEnum(1, this.entity);
                if (this.id !== undefined) writer.writeInt32(2, this.id);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IFileLink): Uint8Array {
        return (data instanceof Message ? (data as MFileLink) : new MFileLink(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MFileLink {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MFileLink();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.entity = reader.readEnum();
                    break;
            case 2:
                    message.id = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MFileLink {
        return MFileLink.deserializeBinaryFromReader(new MFileLink(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MFileLink, reader: BinaryReader) {
        return Object.assign(msg, MFileLink.deserialize(reader))
    };

}
export enum ErrorCode {
    UNSPECIFIED = 0,
    /**
     * 4×× Client Error
     */
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    UNAUTHORIZED_LOGOUT = 40100,
    PAYMENT_REQUIRED = 402,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    METHOD_NOT_ALLOWED = 405,
    NOT_ACCEPTABLE = 406,
    PROXY_AUTHENTICATION_REQUIRED = 407,
    REQUEST_TIMEOUT = 408,
    CONFLICT = 409,
    GONE = 410,
    LENGTH_REQUIRED = 411,
    PRECONDITION_FAILED = 412,
    PAYLOAD_TOO_LARGE = 413,
    REQUEST_URI_TOO_LONG = 414,
    UNSUPPORTED_MEDIA_TYPE = 415,
    REQUESTED_RANGE_NOT_SATISFIABLE = 416,
    EXPECTATION_FAILED = 417,
    IM_A_TEAPOT = 418,
    MISDIRECTED_REQUEST = 421,
    UNPROCESSABLE_ENTITY = 422,
    LOCKED = 423,
    FAILED_DEPENDENCY = 424,
    UPGRADE_REQUIRED = 426,
    PRECONDITION_REQUIRED = 428,
    TOO_MANY_REQUESTS = 429,
    REQUEST_HEADER_FIELDS_TOO_LARGE = 431,
    CONNECTION_CLOSED_WITHOUT_RESPONSE = 444,
    UNAVAILABLE_FOR_LEGAL_REASONS = 451,
    CLIENT_CLOSED_REQUEST = 499,
    /**
     * 5×× Server Error
     */
    INTERNAL_SERVER_ERROR = 500,
    NOT_IMPLEMENTED = 501,
    BAD_GATEWAY = 502,
    SERVICE_UNAVAILABLE = 503,
    GATEWAY_TIMEOUT = 504,
    HTTP_VERSION_NOT_SUPPORTED = 505,
    VARIANT_ALSO_NEGOTIATES = 506,
    INSUFFICIENT_STORAGE = 507,
    LOOP_DETECTED = 508,
    NOT_EXTENDED = 510,
    NETWORK_AUTHENTICATION_REQUIRED = 511,
    NETWORK_CONNECT_TIMEOUT_ERROR = 599,
}
                        




export default () => {}